import type { Reseller, SerializedReseller, Template } from '@enmon/commons/lib/tools';
import { BASE_REST_API_URL } from 'common/constants';
import type { StrictOmit } from '@enmon/commons';
import { BaseApiClient } from './baseApiClient';

export interface UpdateResellersArgs {
  id: Reseller['id'];
  values: ResellerDto;
}

/**
 * @deprecated Use class instead because there is only one implementation of this interface which makes searching for references
 * more difficult, name shouldn't be prefixed too: https://blog.nette.org/en/prefixes-and-suffixes-do-not-belong-in-interface-names.
 */
export interface IResellersApiClient {
  update(args: UpdateResellersArgs): Promise<SerializedReseller>;
}

export type ResellerDto = Partial<
  StrictOmit<Reseller, 'default_template'> & { default_template: Pick<Template, 'id'> }
>;

export class ResellersApiClient extends BaseApiClient implements IResellersApiClient {
  constructor(jwt: string) {
    super('resellers', BASE_REST_API_URL, jwt);
  }

  public async update({ id, values }: UpdateResellersArgs): Promise<SerializedReseller> {
    const response = await this.axios.put<SerializedReseller>(`${id}`, { data: values });

    return response.data;
  }
}
